import { Auth, AuthActionTypes } from '../../actions/Seguridad/auth.actions';

export interface State{
    
    loading: { loading: boolean, recurso: string, message: string, messages: [] };
    error: { hasError: boolean, recurso: string, messageError: string, errors: [] };
}

export const initialState: State = {
    
    loading: { loading: false, recurso: null, message: null, messages: null },
    error: { hasError: false, recurso: null, messageError: null, errors: [] }
}

export function reducer(state = initialState, action:Auth):State{
    switch(action.type){
       
        case AuthActionTypes.loading: {
            return {...state, loading: {...action.payload}}
        }
        case AuthActionTypes.error: {
            return {...state, error: {...action.payload}}
        }
        default:
            return state;
    }
}